<template>
  <el-card class="iot-person public-page-style iot-search-header">
    <div slot="header">
      <el-form :inline="true" :model="getForm">
        <el-form-item>
          <el-input
            size="small"
            clearable
            v-model="getForm.attributeName"
            placeholder="请输入要查询的系统属性名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" plain @click="checkTable()"
            >查询</el-button
          >
        </el-form-item>
        <el-button
          type="primary"
          size="mini"
          class="iot-Attribute-create"
          @click="addcommunicationProtocol()"
          >新增系统属性</el-button
        >
      </el-form>
    </div>
    <div style="height:678px;overflow-y: auto;">

    
    <el-table
      :data="tableData"
      stripe
      style="width: 100%"
      :header-cell-style="{ background: theme.TABLE_HEADER_COLOR }"
    >
    <el-table-column prop="attributeId" label="ID"></el-table-column>
      <el-table-column prop="interfaceId"  :formatter="interfaceName" label="系统名称"></el-table-column>
      <el-table-column prop="attributeName" label="系统属性名称"></el-table-column>
      <el-table-column prop="attributeTag" label="系统属性"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="edit(scope.row.attributeId)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="del(scope.row.attributeId)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    </div>
    <div class="page">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
        :total="total"
        :page-size="getForm.size"
        layout="total, sizes, prev, pager, next, jumper"
        @prev-click="
          () => {
            $set(getForm, 'current', getForm.current - 1);
            getList();
          }
        "
        @next-click="
          () => {
            $set(getForm, 'current', getForm.current + 1);
            getList();
          }
        "
      >
      </el-pagination>
    </div>
    <el-dialog
    top="3%"
      title="填写表单"
      :show-close="false"
      :visible.sync="dataConditionVisinbile"
      :before-close="handleClose"
      :destroy-on-close="true"
      :close-on-press-escape="true"
      :close-on-click-modal="false"
    >
      <el-form
        :model="dataAttributeForm"
        ref="subRef"
        :rules="rules"
        label-position="top"
      >
      <el-form-item label="接口名称" label-width="120" prop="attributeName">
           <el-select
            v-model="dataAttributeForm.interfaceId"
            filterable
            clearable
            size="mini"
            placeholder="请选择
            "
           
          >
            <el-option
              v-for="item in interfaceList"
              :key="item.interfaceId"
              :label="item.interfaceName"
              :value="item.interfaceId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="系统属性名称" label-width="120" prop="attributeName">
          <el-input
            v-model="dataAttributeForm.attributeName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="系统属性" label-width="120" prop="attributeTag">
          <el-input
            v-model="dataAttributeForm.attributeTag"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer"> 
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="dataConditionVisinbile = false"
          >取 消</el-button
        >
       
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import { TABLE_HEADER_COLOR } from "../util/theme";
let that;
export default {
  name: "Attribute",
  props: {
    msg: String,
  },
  data() {
    return {
      theme: { TABLE_HEADER_COLOR },
      tableData: [],
      getForm: {
        current: 1,
        size: 10,
        attributeName: "",
      },
      interfaceList:[],
      total: 0,
      dataConditionVisinbile: false,
      dataAttributeForm: {
        attributeId:"",
        interfaceId: "",
        attributeName: "",
        attributeTag: "",
      },
      isCreate: true,
      rules: {
        attributeName: [
          { required: true, message: "请输入系统属性名称", trigger: "blur" },
        ],
        attributeTag: [
          { required: true, message: "请输入系统属性", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    handleSizeChange(val) {
        that.getForm.size=val;
        that.getList();
      },
      handleCurrentChange(val) {
        that.getForm.current=val;
        that.getList();
      },
    interfaceName:function(row){
    let names 
     that.interfaceList.forEach(item => {
        if(item.interfaceId==row.interfaceId){
           
          names = item.interfaceName;
        }
      });
    
      return names
    },
    getList: function () {
      that.$api.Attribute
        .getAttributePage(that.getForm)
        .then((response) => {
       
          that.tableData = response.data.records;
          that.total = response.data.total;
        });
    },
    handleClose: function () {
      that.dataConditionVisinbile = false;
    },
    addcommunicationProtocol: function () {
      that.dataAttributeForm= {
        attributeId:"",
        interfaceId: "",
        attributeName: "",
        attributeTag: "",
      },
      that.dataConditionVisinbile = true;
      that.isCreate = true;
      
    },
    getInterfaceList(){
      that.$api.Interface
        .getInterfaceList()
        .then((response) => {
          // console.log(response);
          that.interfaceList=response.data
          
        });
    },
    edit: function (id) {
      that.$api.Attribute
        .getAttribute(id)
        .then((response) => {
          
          that.dataConditionVisinbile = true;
          that.isCreate = false;
          that.dataAttributeForm = response.data;
        });
    },
    del: function (id) {
      that
        .$confirm("确认删除", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          that.$api.Attribute
            .delAttribute(id)
            .then(() => {
              that.getList();
              that.$message({
                message: "删除成功",
                type: "success",
              });
            });
        })
        .catch(() => {});
    },
    checkTable: function () {
      that.getList();
    },
    submitForm: function () {
      that.$refs["subRef"].validate((valid) => {
        if (valid) {
          let _api = that.isCreate
            ? that.$api.Attribute.addAttribute(
                that.dataAttributeForm
              )
            : that.$api.Attribute.putAttribute(
                that.dataAttributeForm
              );
          _api.then((response) => {
            if (response.code == 200) {
              that.dataConditionVisinbile = false;
              that.isCreate = true;
              that.getList();
              that.$message({
                type: "success",
                message: "请求成功",
              });
              that.$refs.subRef.resetFields();
            }
          });
        }
      });
    },
  },
  beforeMount: function () {
    that = this;
  },
  mounted: function () {
    that.getList();
    that.getInterfaceList();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.iot-Attribute-create {
  float: right;
  margin-top: 10px;
}
.iot-Attribute-permission {
  height: 387px;
}
.iot-search-header >>> .el-card__header {
  padding: 0 18px;
}
.iot-person >>> .el-select {
  width: 100%;
}
.page{
  display: flex;
  justify-content: flex-end;
}
</style>
